<app-one-single-filter [data]="this.data.filterInfo" [selectedItem]="this.data.selectedInfo" (firstId)="getValue($event)"></app-one-single-filter>
<div mat-dialog-actions style="display: flex; justify-content: flex-start;gap: 2rem; float:right">
    <button class="btn btn-home" mat-button (click)="onNoClick()">Cancel</button>
    <button class="btn btn-home" mat-button [mat-dialog-close]="data.selectedInfo" cdkFocusInitial>Ok</button>
  </div>
